import { render, staticRenderFns } from "./DetailBatchLelang.vue?vue&type=template&id=0563c516&"
import script from "./DetailBatchLelang.vue?vue&type=script&lang=js&"
export * from "./DetailBatchLelang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports